import { SUPPORTED_LOCALES, buildLocaleCookiePaths } from "./locales";

export const ANALYTICS_CONSENT_COOKIE = "acceptCookie";
let memoryConsent;

export function readAnalyticsConsent(cookieString) {
  if (typeof cookieString === "undefined") {
    if (memoryConsent) return memoryConsent;
    try {
      cookieString = document.cookie;
    } catch (error) {
      cookieString = "";
    }
  }
  const cookies = (typeof cookieString === "string" ? cookieString : "")
    .split(";")
    .map(part => part.trim());
  // Preserve existing choices. A conflicting route-specific rejection takes precedence.
  if (cookies.includes("acceptCookie=declineCookie")) return "denied";
  if (cookies.includes("acceptCookie=acceptCookie")) return "granted";
  return "pending";
}

export function clearCookieEverywhere(name) {
  const paths = new Set(buildLocaleCookiePaths(SUPPORTED_LOCALES));
  const parts = window.location.pathname.split("/");
  while (parts.length) {
    paths.add(parts.join("/") || "/");
    parts.pop();
  }
  const domains = [""];
  const hostParts = window.location.hostname.split(".");
  while (hostParts.length > 1) {
    domains.push(`; domain=${hostParts.join(".")}`);
    hostParts.shift();
  }
  paths.forEach(path => {
    domains.forEach(domain => {
      try {
        document.cookie = `${name}=; Max-Age=0; path=${path}${domain}; SameSite=Lax`;
      } catch (error) {
        // Some embedded/private browser contexts disable cookie access entirely.
      }
    });
  });
}

export function writeAnalyticsConsent(status) {
  memoryConsent = undefined;
  try {
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    const attributes = `; Max-Age=31536000; path=/; SameSite=Lax${secure}`;
    // Remove route-specific legacy choices before writing the site-wide choice used by GTM.
    clearCookieEverywhere(ANALYTICS_CONSENT_COOKIE);
    if (status !== "pending") {
      document.cookie = `${ANALYTICS_CONSENT_COOKIE}=${
        status === "granted" ? "acceptCookie" : "declineCookie"
      }${attributes}`;
    }
    if (readAnalyticsConsent() !== status) memoryConsent = status;
  } catch (error) {
    memoryConsent = status;
  }
}

export function clearAnalyticsIdentity(projectToken) {
  const prefix = `ph_${projectToken}_`;
  clearCookieEverywhere(`${prefix}posthog`);
  ["localStorage", "sessionStorage"].forEach(storeName => {
    try {
      const storage = window[storeName];
      Object.keys(storage).forEach(key => {
        if (key.startsWith(prefix)) storage.removeItem(key);
      });
    } catch (error) {
      // Storage can be blocked by browser policy; consent controls must still work.
    }
  });
}
